import { useIntl } from "react-intl";
const CustomerLimit = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomerLimit.header",
            defaultMessage: "Customer limit"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomerLimit.body",
            defaultMessage:
                "Customers are unlicensed users who send requests to your service project through the portal, email, or widget."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomerLimit.body2",
            defaultMessage:
                "For example, an employee raises a request to an internal service desk. This employee has access to the portal but no product access to the project. Employees like these are usually internal customers."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.CustomerLimit.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about customers."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/jira-service-management-cloud/docs/what-are-user-types-and-roles/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default CustomerLimit;
